export default __webpack_public_path__ + "static/media/green_tick_careadmin_icon.b745276b.svg";